import { AfterContentChecked, ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { MorphingSvgComponent } from '../morphing-svg/morphing-svg.component';
import { HeaderNavComponent } from '../header-nav/header-nav.component';
import { HelpBtnComponent } from '../help-btn/help-btn.component';
import { ProgressBarService } from '../../../_services/progress-bar-service/progress-bar.service';

@Component({
  selector: 'app-onboarding-shell',
  imports: [RouterOutlet, MorphingSvgComponent, HeaderNavComponent, HelpBtnComponent],
  templateUrl: './onboarding-shell.component.html',
  styleUrls: ['../../../../static/styles/components/onboarding-shell.scss'],
})
export class OnboardingShellComponent implements OnInit, AfterContentChecked {
  readonly route = inject(ActivatedRoute);
  readonly progressBar = inject(ProgressBarService);
  readonly cdRef = inject(ChangeDetectorRef);

  hideProgress: boolean = false;

  ngOnInit() {
    this.progressBar.hideProgress$.subscribe((value) => {
      this.hideProgress = value;
      this.cdRef.detectChanges();
    });
  }

  ngAfterContentChecked(): void {
    // No need to subscribe here, just ensure change detection
    this.cdRef.detectChanges();
  }
}
